module.exports = __webpack_public_path__ + "img/oneKey.eb924098.png";